import { Box, easing, FadeProps, Slide } from '@mui/material'
import { FC } from 'react'
import { Fade } from 'utoniq-ui'

import { EmphasisRarityId } from './index'
import {
  AnimationGrowLightCell,
  AnimationRareGrowLightCell,
} from './LightFrame'

type AnimationFrameProps = {
  appear: boolean
  emphasisRarityId: EmphasisRarityId
  rarityEffect?: boolean
  flipped: boolean
  slide: number
  growLightTimes: {
    common: number
    rare: number
  }
  container: HTMLDivElement | null
  addEndListener: () => void
  children: FadeProps['children']
}
/**
 * @description
 * アイテム表示時のアニメーションを付与するラッパー
 */
export const AnimationFrame: FC<AnimationFrameProps> = ({
  appear,
  emphasisRarityId,
  rarityEffect,
  flipped,
  slide,
  growLightTimes,
  children,
  container,
  addEndListener = () => {},
}) => {
  return (
    <Slide
      direction="up"
      in={appear}
      mountOnEnter
      easing={easing.easeInOut}
      container={container}
      timeout={slide}
      addEndListener={addEndListener}
    >
      <Box>
        {rarityEffect ? (
          <AnimationRareGrowLightCell
            emphasisRarityId={emphasisRarityId}
            flipped={flipped}
            animationTime={growLightTimes.rare}
          />
        ) : (
          <AnimationGrowLightCell
            emphasisRarityId={emphasisRarityId}
            flipped={flipped}
            animationTime={growLightTimes.common}
          />
        )}
        <Fade timeout={5000}>{children}</Fade>
      </Box>
    </Slide>
  )
}
